import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { toggleDrawer } from '../../helpers/helpers';

// Translations
import translate from '../Translate.js';

// Dependencies
import DatePicker from 'react-datepicker';
import currencyFormatter from 'currency-formatter';
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';

const PaymentCollect = observer(class PaymentCollect extends React.Component {
  constructor() {
    super();
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.initPayment = this.initPayment.bind(this);
    this.collectAddress = this.collectAddress.bind(this);
  }

  componentWillMount() {
    this.state = {
      startDate: null,
      endDate: null
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.paymentType === 'full') {
      this.setState({
        startDate: null,
        startDateTime: '2000-01-01T00:00:00.000Z',
        endDate: null,
        endDateTime: '2070-01-01T00:00:00.000Z'
      });
    }
  }

  handleDateChange(date, name) {
    this.setState({
      [name]: date
    }, function(){
      if(this.state.startDate && this.state.endDate) {
        console.log(moment(this.state.startDate).local().format('YYYY-MM-DD Z'));

        // Convert the time of the date to 12:00am for start and  11:59pm for end
        const startDate = moment(this.state.startDate).local().format('YYYY-MM-DD Z');
        const startDateTime = moment(`${startDate} 00:00`, 'YYYY-MM-DD Z HH:mm').toISOString();
        const endDate = moment(this.state.endDate).local().format('YYYY-MM-DD Z');
        const endDateTime = moment(`${endDate} 23:59`, 'YYYY-MM-DD Z HH:mm').toISOString();

        // Store the converted date
        this.props.store.PaymentStore.paymentData.startDate = startDateTime;
        this.props.store.PaymentStore.paymentData.endDate = endDateTime

        // Get the balance for the selected date range
        this.props.store.PaymentStore.getBalance(false, true);
      }
    });
  }

  handleLocationChange() {
    // Store the location
    this.props.store.PaymentStore.paymentData.locationSid = this.location.value;

    // Get the balance for the selected location
    this.props.store.PaymentStore.getBalance(false, true);
  }

  initPayment(type) {
    this.props.store.PaymentStore.paymentData.type = type;

    this.collectAddress();
  }

  collectAddress() {
    toggleDrawer(null, this.props.parent, 'PaymentForm');
  }

  render() {
    const { translation } = this.props;
    const { LocationStore, PaymentStore, SessionStore } = this.props.store;
    const { balance } = PaymentStore;
    const currency = SessionStore.defaultCurrency || 'USD';

    return (
      <form className={`slideout ${this.props.open ? 'open' : ''}`}>
        {this.props.paymentType === 'partial' &&
          <fieldset className="form-inline--alt">
            <h5>{translation.collect_payment}</h5>

            <ul className="fields payment-fields">
              <li>
                <label className="lbl-inline preposition" htmlFor="payment-start">{translation.from}</label>

                <DatePicker
                  className="react-datepicker"
                  id="payment-start"
                  selected={this.state.startDate}
                  onChange={(date) => {this.handleDateChange(date, 'startDate')}}
                  maxDate={moment()}
                  placeholderText={translation.date_helper}
                  required
                  aria-required="true"
                  ref={(input) => {this.startDate = input}}
                />

                <label className="lbl-inline preposition" htmlFor="payment-end">{translation.to}</label>

                <DatePicker
                    className="react-datepicker"

                    id="payment-end"
                  selected={this.state.endDate}
                  onChange={(date) => {this.handleDateChange(date, 'endDate')}}
                  maxDate={moment()}
                  placeholderText={translation.date_helper}
                  required
                  aria-required="true"
                  ref={(input) => {this.endDate = input}}
                />
              </li>
            </ul>

            <h5>{translation.location}</h5>

            <ul className="fields">
              <li>
                <label className="select" htmlFor="payment-location">
                  <select
                    id="payment-location"
                    onChange={this.handleLocationChange}
                    ref={(input) => {this.location = input}}
                  >
                    <option value="">{translation.all_locations}</option>

                    {LocationStore.locations.map(
                      (location) =>
                      <option key={location.sid} value={location.sid}>{location.name}</option>
                    )}
                  </select>
                </label>
              </li>
            </ul>
          </fieldset>
        }

        <div className="button-group button-group--alt">
          <h4 className="slideout__heading">
            {translation.collect.replace('%total%', currencyFormatter.format(balance, {code: currency}))}
          </h4>

          {balance !== 0 &&
            <button
              className="btn btn--success"
              type="button"
              onClick={() => this.initPayment('online-check')}
            >
              <icons.iconPrint />
              {translation.print_button}
            </button>
          }

          {balance !== 0 &&
            <button
              className="btn btn--success"
              onClick={() => this.initPayment('physical-check')}
              type="button"
            >
              <icons.iconEnvelope />
              {translation.mail_button}
            </button>
          }
        </div>
      </form>
    );
  }
})

export default translate('PaymentCollect')(PaymentCollect);


// WEBPACK FOOTER //
// ./src/app/components/Payments/PaymentCollect.js